// extracted by mini-css-extract-plugin
module.exports = {"article-top-tags":"article-top-tags","tag-item":"tag-item"};